var React = require('react');

function Retry (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(12,12)"},[React.createElement("path",{"d":"M0 -12V12","transform":"rotate(-45deg)","key":0}),React.createElement("path",{"d":"M0 -12V12","transform":"rotate(45deg)","key":1})]));
}

Retry.defaultProps = {"className":"retry-animated","viewBox":"0 0 24 24"};

module.exports = Retry;

Retry.default = Retry;
